import React, {Component} from "react"
import {Button, Checkbox, Container, Divider, Form, Header, Icon, Loader, Modal, Popup, Radio, Segment, Select} from "semantic-ui-react";
import {Link, withRouter} from "react-router-dom";
import {getLocalization, interpolateString, parseMultilineString, parseSingleUnderlinedWordInString} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {
    checkIsOpenEnrollment,
    checkIsVerified,
    findEmployerContribution,
    formatMoneyAmount,
    getBenAdminGreetingName,
    getEnrollmentTimezone,
    getStepProps,
    handleSaveUserProgress,
    HEALTH_PLAN_DETAILS_ROUTE,
    isAIG,
    isAnsel,
    isRenaissance,
    isSymetra,
    registerEmailRecommendation,
    registerPrintRecommendation,
    TELL_US_ABOUT_YOU_ROUTE,
    truncTwoDec,
    uiFlowBenAdmin,
    getSpouseEligibilityString,
} from "../utils/common";
import {isRenaissanceLouisiana} from "../utils/renaissanceLouisiana";
import Steps from "./steps/steps";
import {
    setBrellaSelectTierSelected,
    setCatastrophicCoverage,
    setCostPerOption,
    setCoverageOption,
    setFetchPlanRecommendation,
    setModerateCoverage,
    setPlanContribAndCost,
    setPlanCoverageSelectedAndRecommendedSelect,
    setSevereCoverage,
} from "../actions/userActions";
import Footer from "./footer";
import moment from "moment";
import 'moment-timezone';
import IDontWantCoverageModal from "./iDontWantCoverageModal";
import {
    buildRiderDescription,
    getChronicRiderLabel,
    getMaternityRiderLabel,
    getMentalRiderLabel
} from "../utils/riders";
import PlanWarningsBanner from "./planWarningsBanner";
import {ClickableText, CustomDivider, CustomEmailInput, CustomGrid, CustomModalHeader, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import AdditionalRidersRows from "./additionalRidersRows";
import {show as showToast} from "../actions/toastActions";
import {PersonalizePlanRequest, ScheduleEmailRecommendationRequest, SubmitPlanDetailsRequest} from "../services/types";
import {getPersonalizePlan, scheduleEmailRecommendation, submitPlanDetails} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    const {contractInfo, openEnrollment, ratedClass, riderLabels, eligibility: {domesticPartnerEligible, civilUnionEligible}} = initialData;
    const {moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected} = user;
    const moderateCS = !!moderateCoverageSelected ? moderateCoverageSelected : null;
    const severeCS = !!severeCoverageSelected ? severeCoverageSelected : null;
    const catastrophicCS = !!catastrophicCoverageSelected ? catastrophicCoverageSelected : null;

    const contractTerms = ratedClass?.contractTerms || {};
    const additionalChronic = contractTerms?.chronicBrokerRequested ? contractTerms.chronicCoverageLimit : 0;
    const additionalMental = contractTerms?.mentalBrokerRequested ? contractTerms.mentalCoverageLimit : 0;
    const additionalMaternity = contractTerms?.maternityBrokerRequested ? contractTerms.maternityCoverageLimit : 0;
    const hasRiders = !!additionalChronic || !!additionalMental || !!additionalMaternity;

    const {enrollmentStartDate, enrollmentEndDate} = openEnrollment;
    const start = moment(enrollmentStartDate);
    const end = moment(enrollmentEndDate);
    const isOpenEnrollment = checkIsOpenEnrollment(start, end, getEnrollmentTimezone(initialData));

    return {
        ...ownProps,
        contractInfo: contractInfo,
        additionalChronic,
        additionalMental,
        additionalMaternity,
        hasRiders,
        isOpenEnrollment,
        civilUnionEligible,
        domesticPartnerEligible,
        openEnrollmentStarts: start.format(isRenaissance() ? "MMMM D, YYYY" : "MMMM, Do YYYY"),
        coverageOptions: initialData.coverageOptions,
        costPerOptions: initialData.costPerOptions,
        token: initialData.token,
        coverageOption: user.coverageOption,
        costPerOption: user.costPerOption,
        moderateCoverageSelected: moderateCS,
        severeCoverageSelected: severeCS,
        catastrophicCoverageSelected: catastrophicCS,
        moderateCoverageRecommended: user.moderateCoverageRecommended,
        severeCoverageRecommended: user.severeCoverageRecommended,
        catastrophicCoverageRecommended: user.catastrophicCoverageRecommended,
        user: user,
        initialData, benAdmin,
        isBenAdmin: initialData.uiFlow === uiFlowBenAdmin,
        lang: user.lang,
        employerContribution: !!user.employerContribution ? user.employerContribution : "-",
        cost: !!user.cost ? user.cost : "-",
        recommendationSkipped: !!user.recommendationSkipped,
        riderLabels,
    }
};

class PlanSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            loading: false,
            loadingPersonalize: false,
            submitPlanLoading: false,
            displayInformationAboutCategoriesModal: false,
            displaySeeWhyWeChoseThisAmountsModal: false,
            displayCaptureEmailModal: false,
            capturedEmail: '',
            emailValidationError: null,
            recommendedPlan: "",
            displayDontWantCoverageModal: false,
            tierSelected: {
                value: false,
                enhanced: false,
                premier: false,
            },
            userModifiedData: false,
            submittingEmailRecommendation: false,
        };
    }

    async componentDidMount() {
        const {initialData: {uiFlow}, user, benAdmin, costPerOptions, recommendationSkipped, dispatch, prevRoute: originalPrevRoute} = this.props;
        checkIsVerified(user, benAdmin, uiFlow, this.props);
        await this.handleUserRecommendation({user, recommendationSkipped, costPerOptions});
        const prevRoute = recommendationSkipped ? HEALTH_PLAN_DETAILS_ROUTE : originalPrevRoute;
        dispatch(setPrevRoute(prevRoute));
        this.buildSteps();
    }

    async handleUserRecommendation({user, recommendationSkipped, costPerOptions}) {
        if (recommendationSkipped) {
            await this.handleSkipRecommendation(costPerOptions);
            return;
        }
        if (user.fetchPlanRecommendation) {
            await this.handleFetchPlanRecommendation();
            return;
        }
        await this.handlePlanSelection(user);
    }

    async handleSkipRecommendation(costPerOptions) {
        const {dispatch, initialData: {payrollFrequencySelected, payrollFrequencyMonthly}} = this.props;
        const isMonthly = payrollFrequencySelected === payrollFrequencyMonthly;
        let costPerOption = costPerOptions.filter(cpo => cpo.value === 'Paycheck')[0].id
        if (isMonthly) {
            costPerOption = costPerOptions.filter(cpo => cpo.value === 'Month')[0].id
        }
        dispatch(setCostPerOption(costPerOption));
        const filteredCoverOptions = this.getFilteredCoverOptions();
        const deletes = this.alterDependentInfoBasedOnCoverage(filteredCoverOptions[0].value);
        dispatch(setCoverageOption(filteredCoverOptions[0].value, deletes.deleteChildren, deletes.deleteSpouse));

        await this.personalizePlan(filteredCoverOptions[0].value, costPerOption);
        this.setState({
            tierSelected: {value: true, premier: false, enhanced: false},
            loading: false,
        });
    }

    async handleFetchPlanRecommendation() {
        await this.submitInitialPlanDetails();
        await this.personalizePlan();
    }

    async handlePlanSelection(user) {
        this.setState({
            tierSelected: {...user.selectedTierBrellaSelect},
        });
        await this.submitInitialPlanDetails(true);
        await this.personalizePlan(null, null, true);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    alterDependentInfoBasedOnCoverage = (coverageOptionId) => {
        const {coverageOptions} = this.props;
        const option = coverageOptions.filter((c)=>c.value === coverageOptionId)[0];
        let deleteChildren;
        let deleteSpouse;
        switch(option.value){
            case 'employee':
                deleteChildren = true;
                deleteSpouse = true;
                break;
            case 'spouse':
                deleteChildren = true;
                deleteSpouse = false;
                break;
            case 'child':
                deleteChildren = false;
                deleteSpouse = true;
                break;
            default:
                deleteChildren = false;
                deleteSpouse = false;
        }
        return {deleteChildren, deleteSpouse};
    }

    personalizePlan = async (forcedCoverageOption, forcedCostPerOpt, useSelectedPlanInsteadOfRecommended) => {
        this.setState({loadingPersonalize: true});
        try {
            const {token, additionalChronic, additionalMental, additionalMaternity, coverageOption, costPerOption, costPerOptions, moderateCoverageSelected, severeCoverageSelected, catastrophicCoverageSelected, initialData, isBenAdmin, user} = this.props;
            const {userModifiedData, tierSelected} = this.state;
            let selectedCostPerOpt;
            if (!!forcedCostPerOpt) {
                selectedCostPerOpt = forcedCostPerOpt;
            } else {
                selectedCostPerOpt = !!costPerOptions && costPerOptions.filter(cpo => cpo.id === costPerOption)[0].value;
            }
            const payrollFreq = selectedCostPerOpt === 'Month' ? initialData.payrollFrequencyMonthly : initialData.payrollFrequencySelected;
            let coverageOpt = coverageOption;
            if (!!forcedCoverageOption) {
                coverageOpt = forcedCoverageOption;
            }

            let selectedPlan = "VALUE";
            if (tierSelected.premier) {
                selectedPlan = "PREMIER";
            } else if (tierSelected.enhanced) {
                selectedPlan = "ENHANCED";
            }
            let ageAtPolicyEffectiveDate = initialData.ageAtPolicyEffectiveDate;
            if(isBenAdmin){
                ageAtPolicyEffectiveDate = moment(initialData.policy.polEDate, 'YYYY-MM-DD').diff(moment(user.birthdate, 'MM/DD/YYYY'), 'years');
            }
            const request = new PersonalizePlanRequest({
                familyTierValue: coverageOpt,
                moderateBenefit: !!moderateCoverageSelected ? moderateCoverageSelected : 0,
                severeBenefit: !!severeCoverageSelected ? severeCoverageSelected : 0,
                catastrophicBenefit: !!catastrophicCoverageSelected ? catastrophicCoverageSelected : 0,
                quoteInfo: initialData.quoteInfo,
                mentalBenefit: additionalMental,
                chronicBenefit: additionalChronic,
                maternityBenefit: additionalMaternity,
                ageAtPolicyEffectiveDate: ageAtPolicyEffectiveDate,
                employerContribution: initialData.employerContribution,
                token,
                presets: initialData.presets,
                payrollFrequencySelected: payrollFreq,
                userModifiedData,
                planOffering: initialData.contractInfo.planOffering,
                ratedClassRates: initialData.ratedClass.ratedClassRates,
                userActionData: {
                    brellaSelectPlan: selectedPlan,
                }
            });
            let result = await getPersonalizePlan(request)
            if (!!result && !!result.data) {
                const data = result.data;
                this.props.dispatch(setPlanCoverageSelectedAndRecommendedSelect(data.costValue, data.costEnhanced, data.costPremier,
                    data.contribValue, data.contribEnhanced, data.contribPremier));

                const {recommendedPlan} = this.state;
                let plan = recommendedPlan;
                if(!!useSelectedPlanInsteadOfRecommended){
                    const {tierSelected} = this.state;
                    plan = "value"
                    if(tierSelected.enhanced){
                        plan = "enhanced"
                    } else if(tierSelected.premier){
                        plan = "premier"
                    }
                }

                let cost = data.costValue;
                let contrib = data.contribValue;
                let presets = initialData.presets;
                let selectedPreset = presets.value;
                if(plan === 'enhanced'){
                    cost = data.costEnhanced;
                    contrib = data.contribEnhanced;
                    selectedPreset = presets.enhanced;
                } else if (plan === 'premier'){
                    cost = data.costPremier;
                    contrib = data.contribPremier;
                    selectedPreset = presets.premier;
                }
                const ec = contrib ? contrib : 0.0;
                this.props.dispatch(setPlanContribAndCost(truncTwoDec(ec), truncTwoDec(cost)));
                const d = selectedPreset;
                this.props.dispatch(setModerateCoverage(d.moderate));
                this.props.dispatch(setCatastrophicCoverage(d.catastrophic));
                this.props.dispatch(setSevereCoverage(d.severe));
            }
            this.setState({loadingPersonalize: false});
        } catch (e) {
            console.log(e);
            this.setState({loadingPersonalize: false})
        }
    }

    submitInitialPlanDetails = async (dontChangeUserElections) => {
        this.setState({loading: true});
        try {
            const {user, token, initialData, coverageOptions, costPerOptions, isBenAdmin, recommendationSkipped} = this.props;
            if(user.highDeductibleInfo === null || user.leftoverMoney === null){
                this.setState({loading: false});
                return;
            }
            let ageAtPolicyEffectiveDate = initialData.ageAtPolicyEffectiveDate;
            if(isBenAdmin){
                ageAtPolicyEffectiveDate = moment(initialData.policy.polEDate, 'YYYY-MM-DD').diff(moment(user.birthdate, 'MM/DD/YYYY'), 'years');
            }
            const request = new SubmitPlanDetailsRequest({
                token: token,
                maritalStatusId: user.maritalStatus,
                dependentsId: user.dependents,
                copayId: user.typicallyPayInfo,
                highDeductibleInfoId: user.highDeductibleInfo,
                leftoverMoneyId: user.leftoverMoney,
                ageAtPolicyEffectiveDate,
                payrollFrequencySelected: initialData.payrollFrequencySelected,
            });
            let result = await submitPlanDetails(request)
            if (!!result && !!result.data && !!result.data.select) {
                const data = result.data;
                const dataSelect = result.data.select;
                const recommendedPreset = !recommendationSkipped && dataSelect.selectPreset;
                const recommendedOption = data.familyTierValue;
                const deletes = this.alterDependentInfoBasedOnCoverage(recommendedOption);
                if (!dontChangeUserElections) {
                    this.props.dispatch(setCoverageOption(recommendedOption, deletes.deleteChildren, deletes.deleteSpouse));
                }

                if (!dontChangeUserElections) {
                    const isMonthly = initialData.payrollFrequencySelected === initialData.payrollFrequencyMonthly;
                    let costPerOption = costPerOptions.filter(cpo => cpo.value === 'Paycheck')[0].id
                    if (isMonthly) {
                        costPerOption = costPerOptions.filter(cpo => cpo.value === 'Month')[0].id
                    }
                    this.props.dispatch(setCostPerOption(costPerOption));
                }

                const ec = findEmployerContribution(recommendedOption, coverageOptions, initialData.employerContribution);
                if (!!recommendedPreset) {
                    const ts = this.state.tierSelected;
                    const recommendedPresetLC = recommendedPreset.toLowerCase();
                    if (!dontChangeUserElections) {
                        ts[recommendedPresetLC] = true;
                    }
                    this.setState({
                        recommendedPlan: recommendedPresetLC,
                        tierSelected: {...ts},
                        loading: false,
                    });

                    const {user: {costValue, costEnhanced, costPremier}} = this.props;
                    let cost = costValue;
                    if(recommendedPresetLC === 'enhanced'){
                        cost = costEnhanced;
                    } else if (recommendedPresetLC === 'premier'){
                        cost = costPremier;
                    }

                    let presets = initialData.presets;
                    if (!presets) {
                        presets = {
                            value: {severe: 0, moderate: 0, catastrophic: 0},
                            premier: {severe: 0, moderate: 0, catastrophic: 0},
                            enhanced: {severe: 0, moderate: 0, catastrophic: 0}
                        }
                    }
                    const d = presets[recommendedPreset.toLowerCase()];
                    this.props.dispatch(setModerateCoverage(d.moderate));
                    this.props.dispatch(setCatastrophicCoverage(d.catastrophic));
                    this.props.dispatch(setSevereCoverage(d.severe));
                    this.props.dispatch(setPlanContribAndCost(truncTwoDec(ec), truncTwoDec(cost)))
                } else {
                    this.props.dispatch(setPlanContribAndCost(truncTwoDec(ec), 0))
                    this.setState({loading: false});
                }
            } else {
                this.setState({loading: false});
            }
        } catch (e) {
            console.error(e);
            this.setState({loading: false})
        }
    }

    presetLabel = (title, full = false) => {
        const { lang } = this.props
        const slug = title.toLowerCase()
        const localization = getLocalization(lang)
        const strings = localization.plan;
        const label = full ? strings[`${slug}Plan`] : strings[slug]

        return label ?? `##${slug}##`
    }

    doSendEmailRecommendation = async () => {
        const {capturedEmail, tierSelected} = this.state;
        if (capturedEmail.length === 0) {
            return;
        }
        registerEmailRecommendation(this.props.initialData.token);
        this.setState({submittingEmailRecommendation: true});

        const {
            benAdmin, additionalChronic, additionalMental, additionalMaternity, initialData,
            user: {costValue, costEnhanced, costPremier, contribValue, contribEnhanced, contribPremier},
            costPerOptions, costPerOption, coverageOption, coverageOptions,
            isBenAdmin, user, openEnrollmentStarts, lang, riderLabels
        } = this.props;

        const localization = getLocalization(lang);
        const strings = localization.plan;

        try {
            const coverageOptionLabel = coverageOptions.filter(co => co.value === coverageOption)[0];
            const ts = tierSelected;
            let moderate, severe, catastrophic, cost, contrib;
            const {presets} = initialData;

            if (ts.value) {
                moderate = presets.value.moderate;
                severe = presets.value.severe;
                catastrophic = presets.value.catastrophic;
                cost = costValue;
                contrib = contribValue;
            } else if (ts.premier) {
                moderate = presets.premier.moderate;
                severe = presets.premier.severe;
                catastrophic = presets.premier.catastrophic;
                cost = costPremier;
                contrib = contribPremier;
            } else if (ts.enhanced) {
                moderate = presets.enhanced.moderate;
                severe = presets.enhanced.severe;
                catastrophic = presets.enhanced.catastrophic;
                cost = costEnhanced;
                contrib = contribEnhanced;
            }

            const payFrequency = (!!costPerOptions && costPerOptions.filter(cpo => cpo.id === costPerOption)[0].value).toLowerCase() || '';
            const isMonthly = payFrequency.toLowerCase() === 'month';

            let payFrequencyTranslated = strings.paycheck.toLowerCase();
            if (isMonthly) {
                payFrequencyTranslated = strings.monthly.toLowerCase();
            }
            let coverageOptionLabelTranslated = coverageOptionLabel.value
            switch (coverageOptionLabelTranslated) {
                case('employee'): {
                    coverageOptionLabelTranslated = strings.coverMySelf;
                    break;
                }
                case('spouse'): {
                    coverageOptionLabelTranslated = strings.coverSpouse;
                    break;
                }
                case('child'): {
                    coverageOptionLabelTranslated = strings.coverChild;
                    break;
                }
                case('family'): {
                    coverageOptionLabelTranslated = strings.coverFamily;
                    break;
                }
                default:
                    return false;
            }

            let firstName = user.firstName;
            if (isBenAdmin) {
                firstName = getBenAdminGreetingName(benAdmin, initialData.distributionChannel);
            }

            const {yourBrellaPlanAlsoIncludes} = localization;
            const {
                chronicDetails1, chronicDetails2, chronicDetailsAmount,
                mentalDetails1, mentalDetails2, mentalDetailsAmount,
                maternityDetails1, maternityDetails2, maternityDetails4, maternityDetailsAmount
            } = yourBrellaPlanAlsoIncludes;

            const chronicTitle = getChronicRiderLabel(yourBrellaPlanAlsoIncludes, riderLabels);
            const chronicDescription = buildRiderDescription(chronicDetails1, chronicDetailsAmount, chronicDetails2, chronicTitle);

            const mentalTitle = getMentalRiderLabel(yourBrellaPlanAlsoIncludes, riderLabels);
            const mentalDescription = buildRiderDescription(mentalDetails1, mentalDetailsAmount, mentalDetails2, mentalTitle);

            const maternityTitle = getMaternityRiderLabel(yourBrellaPlanAlsoIncludes, riderLabels);
            const maternityDescription = buildRiderDescription(maternityDetails1, maternityDetailsAmount, maternityDetails2 + maternityDetails4, maternityTitle);

            const payload = new ScheduleEmailRecommendationRequest({
                firstName: firstName,
                moderateRecommendation: formatMoneyAmount(moderate),
                severeRecommendation: formatMoneyAmount(severe),
                catastrophicRecommendation: formatMoneyAmount(catastrophic),
                chronic: formatMoneyAmount(additionalChronic),
                mental: formatMoneyAmount(additionalMental),
                maternity: formatMoneyAmount(additionalMaternity),
                employerContribution: formatMoneyAmount(parseFloat(contrib)),
                yourTotalCost: formatMoneyAmount(parseFloat(cost)),
                payFrequency: payFrequencyTranslated,
                mailTo: capturedEmail,
                iWantToCover: coverageOptionLabelTranslated,
                uiFlow: initialData.uiFlow,
                language: lang,
                openEnrollmentStarts: openEnrollmentStarts,
                groupType: initialData.contractInfo.groupType,
                chronicTitle,
                chronicDescription,
                mentalTitle,
                mentalDescription,
                maternityTitle,
                maternityDescription,
            });

            await scheduleEmailRecommendation(payload);
            this.props.dispatch(showToast({
                type: 'success',
                message: strings.emailSubmitted
            }));
        } catch (e) {
            console.error(e);
            this.props.dispatch(showToast({
                type: 'error',
                message: strings.submitEmailErrorMessage
            }));
        } finally {
            this.setState({
                submittingEmailRecommendation: false,
                displayCaptureEmailModal: false,
            });
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 2, uiFlow, distributionChannel)});
    }

    renderSeeWhyWeChoseThisAmountsModal = (strings) => {
        const {displaySeeWhyWeChoseThisAmountsModal} = this.state;
        const onModalClose = () => this.setState({displaySeeWhyWeChoseThisAmountsModal: false});
        return <Modal open={displaySeeWhyWeChoseThisAmountsModal} size={'tiny'} onClose={onModalClose}>
            <CustomModalHeader title={strings.seeWhyWeChoseTitle} onClose={onModalClose}/>
            <Modal.Content style={{maxHeight:'513px', overflowY: 'auto'}} className={"small"}>
                <p>{strings.modalP1}</p>
                <p><b>{strings.modalP2Title}</b><br/>
                    {strings.modalP2}
                </p>

                <p><b>{strings.modalP3Title}</b><br/>
                    {strings.modalP3}
                </p>

                <p><b>{strings.modalP4Title}</b><br/>
                    {strings.modalP4}
                </p>

                <p><b>{strings.modalP5Title}</b><br/>
                    {strings.modalP5}
                </p>
            </Modal.Content>
        </Modal>
    }

    renderCaptureEmailModal = (strings) => {
        const {displayCaptureEmailModal, capturedEmail, emailValidationError, submittingEmailRecommendation} = this.state;
        const onModalClose = () => this.setState({displayCaptureEmailModal: false});
        return <Modal open={displayCaptureEmailModal} size={'tiny'} onClose={onModalClose}>
            <CustomModalHeader title={strings.emailMyRecommendation} onClose={onModalClose}/>
            <Modal.Content>
                {strings.emailMyRecommendationDescr}
                <Form style={{marginTop: '2em', marginBottom: '1em'}}>
                    <CustomEmailInput
                        required
                        value={capturedEmail}
                        onChange={(event, {value}) => {
                            this.setState({capturedEmail: value});
                        }}
                        setEmailError={(error) => {this.setState({emailValidationError: error})}}
                    />
                </Form>
                <span style={{float: 'right', marginTop: '0.2em', marginBottom: '1em'}}>
                    <Button className={'emptyButton'}
                            onClick={() => this.setState({displayCaptureEmailModal: false})}>{strings.cancel}</Button>
                    <Button primary disabled={capturedEmail.length === 0 || !!emailValidationError || submittingEmailRecommendation} loading={submittingEmailRecommendation}
                            onClick={async () => await this.doSendEmailRecommendation(capturedEmail)}>
                        {strings.submit}
                    </Button>
                </span>
            </Modal.Content>
        </Modal>
    }

    selectPlan = (title, dispatchSelection) => {
        return async () => {
            const selectedPlan = title.toLowerCase();
            const tierSelected = {
                value: selectedPlan === 'value',
                premier: selectedPlan === 'premier',
                enhanced: selectedPlan === 'enhanced',
            };
            this.setState({
                tierSelected,
                userModifiedData: true,
            });
            const {value, premier, enhanced} = tierSelected;
            this.props.dispatch(setBrellaSelectTierSelected(value, premier, enhanced));
            await this.personalizePlan(null, null, true);
            dispatchSelection();
        }
    }

    renderRecommendationTier = (strings, title, moderateVal, severeVal, catastrophicVal, employerContr, cost, dispatchSelection) => {
        const slug = title.toLowerCase();
        const {costPerOptions, costPerOption} = this.props;
        const {tierSelected, recommendedPlan, loadingCostsPerOption} = this.state;
        const isRecommended = slug === recommendedPlan.toLowerCase();
        let isSelectedTier = tierSelected[slug]
        const noSelectedTier = !tierSelected || !(tierSelected.enhanced || tierSelected.premier || tierSelected.value);
        if (noSelectedTier) isSelectedTier = isRecommended;
        let costPerOptionLabel = (!!costPerOptions && !!costPerOption && costPerOptions.filter(cpo => cpo.id === costPerOption)[0].value.toLowerCase()) || '';
        let erContribCostPerOptionLabel = '';
        if (costPerOptionLabel !== '') {
            if (costPerOptionLabel === "month") {
                costPerOptionLabel = strings.month;
                erContribCostPerOptionLabel = strings.monthly;
            } else {
                costPerOptionLabel = strings.paycheck;
                erContribCostPerOptionLabel = strings.paycheck
            }
        }

        return (
            <CustomGrid.Column>
                <Segment basic loading={loadingCostsPerOption} style={{margin: 0, padding: 0}}>
                    <CustomGrid columns={1} style={{margin: 0}}>
                        <CustomGrid.Column className={`planSelectTable ${isSelectedTier && "selectedPlanCard"}`}>
                            <div className={`planSelectTableHeader ${isSelectedTier && "selectedPlanCardHeader"}`}>
                                <Checkbox radio style={{display: 'block', float: 'left', marginTop: '7px'}}
                                          checked={isSelectedTier}
                                          onClick={isSelectedTier ? null : this.selectPlan(title, dispatchSelection)}/>
                                <span style={{marginLeft: '-16px'}}>
                                <Header as={'h4'} className={`planSelectTableHeaderTitle ${isSelectedTier && "selectedPlanCardTitle"}`}>{isAnsel() ? title : this.presetLabel(slug)}</Header>
                            </span>
                            </div>
                            <div style={{paddingLeft: '1em', paddingRight: '1em'}}>
                                <div className={"smaller"} style={{marginTop: '1.5em', marginBottom: '0.6em'}}>
                                    <p><b>{strings.payouts}</b></p>
                                </div>
                                <CustomGrid>
                                    <CustomGrid.Row columns={1} className={'printableOnly'}>
                                        <CustomGrid.Column>
                                            <div className={"smaller"}>{strings.moderate}</div>
                                            <b>${formatMoneyAmount(moderateVal)}</b>
                                        </CustomGrid.Column>
                                        <CustomGrid.Column>
                                            <div className={"smaller"}>{strings.severe}</div>
                                            <b>${formatMoneyAmount(severeVal)}</b>
                                        </CustomGrid.Column>
                                        <CustomGrid.Column>
                                            <div className={"smaller"}>{strings.catastrophic}</div>
                                            <b>${formatMoneyAmount(catastrophicVal)}</b>
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>
                                    <CustomGrid.Row columns={3} className={'nonprintable'}>
                                        <CustomGrid.Column>
                                            <div className={"smaller"}>{strings.moderate}</div>
                                            <b>${formatMoneyAmount(moderateVal)}</b>
                                        </CustomGrid.Column>
                                        <CustomGrid.Column>
                                            <div className={"smaller"}>{strings.severe}</div>
                                            <b>${formatMoneyAmount(severeVal)}</b>
                                        </CustomGrid.Column>
                                        <CustomGrid.Column>
                                            <div className={"smaller"}>{strings.catastrophic}</div>
                                            <b>${formatMoneyAmount(catastrophicVal)}</b>
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>
                                </CustomGrid>

                                <Divider hidden/>

                                {!!employerContr && employerContr > 0 &&
                                    <div style={{marginBottom: '0.6em'}}>
                                        <div className={"smaller"}>{strings.employerContribution}</div>
                                        <b>${!!employerContr ? truncTwoDec(employerContr) : employerContr}</b>/<small>{erContribCostPerOptionLabel}</small>
                                    </div>
                                }

                                <Divider/>
                                <div style={{paddingLeft: '1em', paddingRight: '1em'}}>
                                    <CustomGrid textAlign={'center'}>
                                        <CustomGrid.Column>
                                            <Header as={"h3"} style={{margin: 0}}>${!!cost ? truncTwoDec(cost) : cost}</Header>
                                            <small>{strings.costPer}{' '}{costPerOptionLabel}</small><br/>
                                            {((isRecommended && strings.recommendedForYou) && <b className={'recommendedPlanColor small'}>
                                                    {(isRecommended && strings.recommendedForYou)}
                                            </b>
                                            ) || <div>&nbsp;</div>
                                            }
                                        </CustomGrid.Column>
                                    </CustomGrid>
                                </div>
                                <Divider hidden/>
                            </div>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Segment>
            </CustomGrid.Column>
        );
    }

    getRecommendedPlanLabelForDescription = (strings) => {
        const {recommendedPlan} = this.state;
        const planLabels = {
            'value': isAnsel() || isAIG() || isRenaissance() ? strings.value : strings.valuePlan,
            'enhanced': isAnsel() || isAIG() || isRenaissance()  ? strings.enhanced : strings.enhancedPlan,
            'premier': isAnsel() || isAIG() || isRenaissance()  ? strings.premier : strings.premierPlan,
        };
        return planLabels[recommendedPlan.toLowerCase()];
    }

    renderPayFrequencySelect = () => {
        const {costPerOptions, initialData, lang} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.plan;
        const paycheck = costPerOptions.filter(cpo => cpo.value === 'Paycheck')[0];
        const monthly = costPerOptions.filter(cpo => cpo.value === 'Month')[0];
        const opts = [];
        let result = null;
        if (initialData.payrollFrequencySelected !== initialData.payrollFrequencyMonthly) {
            opts.push({key: paycheck.id, value: paycheck.id, text: `${strings.costPer} ${strings.paycheck.toLowerCase()}`});
            opts.push({key: monthly.id, value: monthly.id, text: `${strings.costPer} ${strings.month.toLowerCase()}`});
            result = <Select options={opts}
                             value={this.props.costPerOption}
                             className={'planPayFrequencySelect'}
                             onChange={async (a, {value}) => {
                                 this.setState({userModifiedData: true, loadingCostsPerOption: true});
                                 await this.props.dispatch(setCostPerOption(value));
                                 await this.personalizePlan(null, null, true);
                                 this.setState({loadingCostsPerOption: false});
                             }}/>
        }
        return result;
    }

    getFilteredCoverOptions = () => {
        const {user, coverageOptions, lang, civilUnionEligible, domesticPartnerEligible} = this.props;
        const {maritalStatus, dependents} = user;
        const localization = getLocalization(lang);
        const strings = localization.plan;

        const hasSpouseEligibility = civilUnionEligible || domesticPartnerEligible
        const renaissanceLouisiana = isRenaissanceLouisiana(this.props.initialData);
        const coverSpouse = renaissanceLouisiana ? strings.coverSpouseLouisiana : strings.coverSpouse;
        const spouseString = (hasSpouseEligibility && !renaissanceLouisiana && parseSingleUnderlinedWordInString(strings.coverSpouseUnderscore)) || coverSpouse;

        const stringsMap = {
            employee: strings.coverMySelf,
            spouse: spouseString,
            child: parseSingleUnderlinedWordInString(strings.coverChildUnderscore),
            family: strings.coverFamily,
        };

        const coverOpts = coverageOptions.map(({key, value, text}) => ({key, text: <label>{stringsMap[value] ?? text}</label>, value}));

        const MARRIED_ID = 1;
        const KIDS_UNDER_18 = 1;
        const KIDS_OVER_18 = 2;
        const NO_KIDS = 3;
        let filteredCoverOptions;
        if (maritalStatus === MARRIED_ID) {
            if (dependents === NO_KIDS) {
                filteredCoverOptions = coverOpts.filter((opts) => !opts.value.includes('family') && !opts.value.includes('child'))
            } else {
                filteredCoverOptions = coverOpts;
            }
        } else {
            if (dependents === KIDS_UNDER_18 || dependents === KIDS_OVER_18) {
                filteredCoverOptions = coverOpts.filter((opts) => !opts.value.includes('family') && !opts.value.includes('spouse'))
            } else {
                filteredCoverOptions = coverOpts.filter((opts) => !opts.value.includes('family') && !opts.value.includes('spouse') && !opts.value.includes('child'))
            }
        }
        return filteredCoverOptions;
    }

    get hasRecommendation() {
        const {recommendationSkipped} = this.props;
        return !recommendationSkipped;
    }

    handleCoverageChange = async (e, {value}) => {
        this.setState({userModifiedData: true});
        const {deleteChildren, deleteSpouse} = this.alterDependentInfoBasedOnCoverage(value);
        await this.props.dispatch(setCoverageOption(value, deleteChildren, deleteSpouse));
        await this.personalizePlan(null, null, true);
        this.props.dispatch(setFetchPlanRecommendation(false));
    }

    render() {
        const {
            stepProps,
            loading,
            displayDontWantCoverageModal,
        } = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const {
            lang, isBenAdmin, initialData, hasRiders, user: {costValue, costEnhanced, costPremier, contribValue,
            contribEnhanced, contribPremier}, coverageOption, user, isOpenEnrollment, openEnrollmentStarts,
            domesticPartnerEligible, civilUnionEligible
        } = this.props;
        let isPaperEnrollment = !!initialData.isPaperEnrollment;
        let presets = initialData.presets;
        if (!presets) {
            presets = {
                value: {severe: 0, moderate: 0, catastrophic: 0},
                premier: {severe: 0, moderate: 0, catastrophic: 0},
                enhanced: {severe: 0, moderate: 0, catastrophic: 0}
            }
        }
        const localization = getLocalization(lang);
        const strings = localization.plan;
        const stringsAlsoIncludes = localization.yourBrellaPlanAlsoIncludes;
        const renaissanceLouisiana = isRenaissanceLouisiana(initialData);

        let title = strings.title;
        let descriptionGreen = <ClickableText href onClick={() => this.setState({displaySeeWhyWeChoseThisAmountsModal: true})}>
            {strings.basedOnModal}
        </ClickableText>;
        let description = <span className={'printableText'}>
            {strings.basedOnAlternate}
            <span><b>{' '}{this.getRecommendedPlanLabelForDescription(strings)}.{' '}</b></span>
            <span>{' '}{descriptionGreen}.{' '}</span>
            {strings.basedOnAlternate2}
        </span>

        if (!this.hasRecommendation) {
            title = strings.titleSkipped;
            descriptionGreen = <Link to={HEALTH_PLAN_DETAILS_ROUTE}><b>{strings.descriptionGreenSkipped}</b></Link>;
            description = <React.Fragment>{strings.descriptionSkipped}{' '}<span
                className={"colofulText"}>{descriptionGreen}{'\u2192'}</span></React.Fragment>
        }

        const filteredCoverOptions = this.getFilteredCoverOptions();

        if (loading) {
            return <React.Fragment>
                <CustomGrid style={{marginTop: '-8em'}}>
                    <CustomGrid.Column textAlign={'center'} stretched>
                        <Container style={{marginTop: '10%'}}>
                            <S3Image {...IMAGE.LEVERS}/>
                            <Header as={'h4'}>{strings.justAMoment}</Header>
                            <p>{strings.jamDescr}</p>
                        </Container>
                    </CustomGrid.Column>
                </CustomGrid>
            </React.Fragment>;
        } else {
            const defaultSpouseDefinition = getSpouseEligibilityString(domesticPartnerEligible, civilUnionEligible, strings);
            const spouseDefinition = renaissanceLouisiana && defaultSpouseDefinition
                ? localization.tellUsAboutYou.partnerClarificationLouisiana
                : defaultSpouseDefinition;

            return (
                <React.Fragment>
                    {this.renderSeeWhyWeChoseThisAmountsModal(strings)}
                    {this.renderCaptureEmailModal(strings)}
                    {!!displayDontWantCoverageModal && (
                        <IDontWantCoverageModal opened onModalClose={() => this.setState({displayDontWantCoverageModal: false})}/>
                    )}
                    <Container className={`contentContainer contentContainerSelect`}>
                        <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                        <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                            <CustomGrid.Column width={12}>
                                <CustomGrid stackable container>
                                    <CustomGrid.Row columns={1} centered>
                                        <CustomGrid.Column textAlign={'left'} width={12}>
                                            <Header as='h2'
                                                    className={'printableTitle'}>{title}</Header>
                                            <p>{description}</p>
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>

                                    <PlanWarningsBanner />

                                    <CustomGrid.Row style={{marginBottom: 0, paddingBottom: 0,}}>
                                        <CustomGrid.Column width={8}>
                                            <Header as={'h4'}>{strings.iWantToCover}</Header>
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>

                                    <CustomGrid.Row style={{marginTop: 0, paddingTop: 0}}>
                                        <CustomGrid.Column width={9}>
                                            <Form>
                                                <Form.Field>
                                                    {filteredCoverOptions.map((opt, idx) => {
                                                        const selected = coverageOption === opt.value;
                                                        let content = <Radio checked={selected} key={idx} label={opt.text}
                                                                             name='radioGroup' onClick={selected ? null : this.handleCoverageChange}
                                                                             style={{marginRight: '0.4em'}} value={opt.value}/>
                                                        if (opt.value === "child") {
                                                            content = <Popup key={idx} content={<span>{parseMultilineString(strings.childrenAreElegible)}</span>}
                                                                             style={{fontSize: '12px'}}
                                                                             trigger={content}/>
                                                        } else if (opt.value === "spouse" && spouseDefinition) {
                                                            content = <Popup wide key={idx} content={<span>{spouseDefinition}</span>}
                                                                             style={{fontSize: '12px'}}
                                                                             trigger={content}/>
                                                        }
                                                        return content;
                                                    })}
                                                </Form.Field>
                                            </Form>
                                        </CustomGrid.Column>
                                        <CustomGrid.Column width={3} textAlign="right">
                                                {this.renderPayFrequencySelect()}
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>

                                    <CustomGrid.Row style={{padding: 0}}>
                                        <CustomGrid.Column>
                                            <div style={{fontSize: "14px"}}>
                                                {parseMultilineString(strings.dontSeeCoverageTierSelect)}{' '}
                                                <Link to={TELL_US_ABOUT_YOU_ROUTE}>{strings.editYourFamily}</Link>
                                            </div>
                                        </CustomGrid.Column>
                                    </CustomGrid.Row>

                                    <CustomGrid.Row columns={3} style={{ justifyContent: 'center' }}>
                                        {presets.value.show !== false && (
                                            this.renderRecommendationTier(strings, "Value",
                                                presets.value.moderate, presets.value.severe, presets.value.catastrophic, contribValue, costValue, ()=>{
                                                    const d = presets.value;
                                                    this.props.dispatch(setModerateCoverage(d.moderate));
                                                    this.props.dispatch(setCatastrophicCoverage(d.catastrophic));
                                                    this.props.dispatch(setSevereCoverage(d.severe));
                                                    this.props.dispatch(setPlanContribAndCost(truncTwoDec(contribValue), truncTwoDec(costValue)));
                                                    this.props.dispatch(setFetchPlanRecommendation(false));
                                                })
                                        )}

                                        {presets.enhanced.show !== false && (
                                            this.renderRecommendationTier(strings, "Enhanced",
                                                presets.enhanced.moderate, presets.enhanced.severe, presets.enhanced.catastrophic, contribEnhanced, costEnhanced, ()=>{
                                                    const d = presets.enhanced;
                                                    this.props.dispatch(setModerateCoverage(d.moderate));
                                                    this.props.dispatch(setCatastrophicCoverage(d.catastrophic));
                                                    this.props.dispatch(setSevereCoverage(d.severe));
                                                    this.props.dispatch(setPlanContribAndCost(truncTwoDec(contribEnhanced), truncTwoDec(costEnhanced)));
                                                    this.props.dispatch(setFetchPlanRecommendation(false));
                                                })
                                        )}

                                        {presets.premier.show !== false && (
                                            this.renderRecommendationTier(strings, "Premier",
                                                presets.premier.moderate, presets.premier.severe, presets.premier.catastrophic, contribPremier, costPremier, () => {
                                                    const d = presets.premier;
                                                    this.props.dispatch(setModerateCoverage(d.moderate));
                                                    this.props.dispatch(setCatastrophicCoverage(d.catastrophic));
                                                    this.props.dispatch(setSevereCoverage(d.severe));
                                                    this.props.dispatch(setPlanContribAndCost(truncTwoDec(contribPremier), truncTwoDec(costPremier)));
                                                    this.props.dispatch(setFetchPlanRecommendation(false));
                                                })
                                        )}
                                    </CustomGrid.Row>

                                    {hasRiders &&
                                        <>
                                            <CustomDivider hidden />
                                            <CustomDivider hidden small />
                                            <CustomGrid.Row columns={1}>
                                                <CustomGrid.Column>
                                                    <Header as={'h3'}>
                                                        {isAIG() || isRenaissance() ? stringsAlsoIncludes.title : <>{STRATEGIC_PARTNER.LABEL}<span className={'plusSignColor'}>+</span></>}
                                                    </Header>
                                                    <p>{stringsAlsoIncludes.yourBrellaPlan}{stringsAlsoIncludes.payoutListed}</p>
                                                </CustomGrid.Column>
                                            </CustomGrid.Row>
                                            <CustomDivider hidden small />
                                            <AdditionalRidersRows />
                                        </>
                                    }

                                    {(isBenAdmin || !isOpenEnrollment) && !isPaperEnrollment &&
                                        <React.Fragment>
                                        <CustomGrid.Row style={{paddingBottom: 0, paddingTop: '2em'}}>
                                                <CustomGrid.Column>
                                                    <Header as={'h4'}>
                                                        {isBenAdmin && strings.readyToMakeYourSelec}
                                                        {!isBenAdmin && strings.nextSteps}
                                                    </Header>
                                                </CustomGrid.Column>
                                            </CustomGrid.Row>
                                            <CustomGrid.Row>
                                                <CustomGrid.Column>
                                                    {isBenAdmin && strings.goToYourEnrollmentPlat}
                                                    {!isBenAdmin && <p>{interpolateString(strings.yourOpenEnrollment, [openEnrollmentStarts])}</p>}
                                                </CustomGrid.Column>
                                            </CustomGrid.Row>
                                            <CustomGrid.Row style={{padding: 0}}>
                                                <CustomGrid.Column>
                                                    <Icon name={'print'} className={'neutral700Text'}/>
                                                    <ClickableText
                                                        onClick={()=> {
                                                            registerPrintRecommendation(this.props.initialData.token);
                                                            window.print();
                                                        }} small>
                                                        {strings.printRecomm}
                                                    </ClickableText>
                                                </CustomGrid.Column>
                                            </CustomGrid.Row>
                                            <CustomGrid.Row style={{paddingTop: 5}}>
                                                <CustomGrid.Column>
                                                    <Icon name={'mail outline'} className={'neutral700Text'}/>
                                                    <ClickableText
                                                        onClick={() => this.setState({displayCaptureEmailModal: true})} small>
                                                        {strings.emailRecomm}
                                                    </ClickableText>
                                                </CustomGrid.Column>
                                            </CustomGrid.Row>
                                        </React.Fragment>
                                    }
                                </CustomGrid>
                            </CustomGrid.Column>
                        </CustomGrid>
                    </Container>
                    {(isBenAdmin || !isOpenEnrollment) && !isPaperEnrollment ? (
                        <Footer
                            className={'nonprintable'}
                            disabled={!this.props.coverageOption || !this.props.costPerOption}
                            showCenterData
                            showTopFooter={false}
                        />
                    ) : (
                        <Footer
                            link={<span><b>{strings.or}</b>
                                <ClickableText onClick={() => this.setState({displayDontWantCoverageModal: true})}>
                                    {' '}{strings.iDontWant}</ClickableText></span>}
                            className={'nonprintable'}
                            buttonText={localization.next}
                            showTopFooter showCenterData
                            onClickCallback={() => {
                                handleSaveUserProgress(initialData.token, user).then();
                                this.props.history.push(this.props.nextRoute)
                            }}
                            disabled={!this.props.coverageOption || !this.props.costPerOption}
                            loading={this.state.submitPlanLoading}/>
                    )
                    }
                </React.Fragment>
            )
        }
    }
}

export default withRouter(connect(mapStateToProps)(PlanSelect));
